import axios from 'axios';
import { QueryParameterType } from '@/composables/state/publicationSearchApp';

if (!import.meta.env.VITE_APP_PUBLICATION_INFO_URL) {
  throw new Error('ABMI API Env not set: VITE_APP_PUBLICATION_INFO_URL');
}

const abmiApiUrl = import.meta.env.VITE_APP_PUBLICATION_INFO_URL;

const abmiAxios = axios.create({
  baseURL: abmiApiUrl
});
/* get all publication, and do counting */
export async function searchPublications (inParams:QueryParameterType) {
  const apiFct = 'query-publication';
  const params = { ...inParams };
  if (params.searchText && params.searchText.length > 0) {
    params.searchKey = [params.searchText];
  }
  try {
    const response = await abmiAxios.get(apiFct, { params });
    const data = response.data;

    return data;
  } catch (error) {
    return (error);
  }
}

/* get all publication, and do counting */
export async function getPublicationTags () {
  const apiFct = 'get-publication-tags';
  try {
    const response = await abmiAxios.get(apiFct, { params: { rootPath: '/publications' } });
    const data = response.data;
    return data;
  } catch (error) {
    return (error);
  }
}
const abmiApi = {
  searchPublications
};

export default abmiApi;
